import { ca } from '@cian/analytics';
import { getProductsData } from '../../selectors/analytics';
import { TExtra } from '../../types/analytics/products';
import { EPromoType } from '../../types/newbuilding/promos';

interface ITrackClickPromoBlock {
  promoType: EPromoType;
  newbuildingId: number;
  promotionId?: number;
}

export function trackClickPromoBlock({ promoType, newbuildingId, promotionId }: ITrackClickPromoBlock) {
  const extra: TExtra = {
    promoId: promotionId,
  };

  ca('eventSite', {
    name: 'oldevent',
    category: 'PromotionsJK',
    action: 'click_block',
    label: promoType,
    products: [getProductsData(newbuildingId, null, extra)],
  });
}

interface ITrackHoverPromoBlock {
  promoType: EPromoType;
  newbuildingId: number;
  promotionId?: number;
}

export function trackHoverPromoBlock({ promoType, newbuildingId, promotionId }: ITrackHoverPromoBlock) {
  const extra: TExtra = {
    promoId: promotionId,
  };

  ca('eventSite', {
    name: 'oldevent',
    category: 'PromotionsJK',
    action: 'hover_block',
    label: promoType,
    products: [getProductsData(newbuildingId, null, extra)],
  });
}

export function trackMorePromosClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'PromotionsJK',
    action: 'click_view_more',
    label: 'more',
    useLastProducts: true,
  });
}
